/**
 * Centralized query keys for the Users feature.
 */

// Organization
export const ORGANIZATION_USERS_LIST_QUERY_KEY = 'organization-users-list';
export const ORGANIZATION_PENDING_INVITATIONS_LIST_QUERY_KEY =
  'organization-pending-invitations-list';

// Staff
export const STAFF_USERS_LIST_QUERY_KEY = 'staff-users-list';
export const STAFF_PENDING_INVITATIONS_LIST_QUERY_KEY = 'staff-pending-invitations-list';
